import type { TokenHost } from './host';
import { createServicesRoutes } from './route';
import { serviceScopes } from './service';

/**
 * The module for the app to mount: its services-hub routes and catalog scopes (plain data; the
 * console stays a lazy chunk behind `route.ts`). The host is a lazy factory, not a value, as in
 * packages/hosting: the app file that builds it is fetched when the route loads, and registered
 * before the console's chunk runs (`route.ts`).
 */
export function createTokenModule(loadHost: () => Promise<TokenHost>) {
  return { servicesRoutes: createServicesRoutes(loadHost), serviceScopes };
}

export type { TokenHost } from './host';
